var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-listing", attrs: { id: "project__list" } },
    [
      _c(
        "b-modal",
        {
          attrs: { type: "warn", title: "Remove Options" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.showRemoveProjectDeli = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.deleteDeliverable()
                        }
                      }
                    },
                    [_vm._v("Delete Deliverable")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.onConfirmRemoveProjectDeli }
                    },
                    [_vm._v("Remove just from this Project")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showRemoveProjectDeli,
            callback: function($$v) {
              _vm.showRemoveProjectDeli = $$v
            },
            expression: "showRemoveProjectDeli"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Please choose one of the following actions below to remove the deliverable."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "project__list" },
        [
          _c("EditProjectModal", {
            ref: "refEditProjectModal",
            attrs: { projectDeliverables: _vm.projectDeliverables }
          }),
          _vm._v(" "),
          _c(
            "b-card",
            {
              staticClass: "project--bottom-section",
              attrs: { "no-body": "", id: "projectBottomCard" }
            },
            [
              _c(
                "b-tabs",
                {
                  attrs: {
                    card: "",
                    "content-class": "add-project-deliverable-tab"
                  },
                  model: {
                    value: _vm.activeProjectTab,
                    callback: function($$v) {
                      _vm.activeProjectTab = $$v
                    },
                    expression: "activeProjectTab"
                  }
                },
                [
                  _c(
                    "b-tab",
                    {
                      staticClass: "project--deliverable--tab-content",
                      attrs: { title: "Project deliverables" }
                    },
                    [_c("b-card-text", [_c("ProjectDeliverableComponent")], 1)],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { title: "Project calendar" } },
                    [_c("ProjectCalendar", { ref: "projectCalendarTab" })],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }